export const injectURLParams = (
	url: string,
	params: Record<string, any> = {}
) => {
	const queryParams = Object.entries(params)
		.map(([key, value]) => `${key}=${value}`)
		.join('&')
	return `${url}${queryParams ? `?${queryParams}` : ''}`
}

export function usePrestation() {
	const getPrestation = async (userId: string) => {
		const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/api/v1/provider-service/list`

		const url = injectURLParams(baseUrl, {
			_populate: 'ownerId',
			ownerId: userId,
		})

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			})

			const data = await response.json()

			if (!data.success || !data.result) {
				console.error(
					'Prestation fetch failed:',
					data.message || 'Unknown error'
				)
				return null
			}

			return data.result
		} catch (error) {
			console.error('Fetch error while retrieving prestations:', error)
			return null
		}
	}

	return { getPrestation }
}
